//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/JamTestNamespace.Subspace.js";
import "../JamTestNamespace/JamTestNamespace.Tagged.js";
let d=[[[0,"Type",0,0]],[[["input"],"NegateAndAddId",{R_:{result:''}},1,0],[["x"],"AddToId",{R_:{result:''}},1,0],[["input"],"SetStruct",{},1,0],[["x","y"],"MultipleOutputArguments2",{R_:{z:''}},0,0]],[]];
SPLM.JamTestNamespace.Subspace.Tagged2 = class extends SPLM.JamTestNamespace.Tagged{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.JamTestNamespace.Subspace.Tagged2";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.JamTestNamespace.Subspace.Tagged2.Struct1 = class{
    constructor(i,d){
        this.i=i;this.d=d;}
    get I(){return this.i}
    set I(val){this.i = val}
    get D(){return this.d}
    set D(val){this.d = val}
};

SPLM.JamTestNamespace.Subspace.Tagged2.ObjType = Object.freeze({
    "TypeTwo" : "TypeTwo", "TypeTwoB" : "TypeTwoB"});

export default SPLM;